<template>
  <div class="chart_con">
     <div id="qChart" ref="qChart"></div>
    <div id="sChart" ref="sChart"></div>
  </div>




  <!-- <div class="charts-page"> -->
    <!-- <div class="va-row">
      <div class="flex md6 xs12">
        <vuestic-widget
          class="chart-widget"
          :headerText="$t('charts.verticalBarChart')"
        >
          <vuestic-chart :data="verticalBarChartData" type="vertical-bar"/>
        </vuestic-widget>
      </div>
      <div class="flex md6 xs12">
        <vuestic-widget
          class="chart-widget"
          :headerText="$t('charts.horizontalBarChart')"
        >
          <vuestic-chart :data="horizontalBarChartData" type="horizontal-bar"/>
        </vuestic-widget>
      </div>
    </div>

    <div class="va-row">
      <div class="flex md12 xs12">
        <vuestic-widget
          class="chart-widget"
          :headerText="$t('charts.lineChart')"
        >
          <vuestic-chart :data="lineChartData" type="line"/>
        </vuestic-widget>
      </div>
    </div> -->

    <!-- <div class="va-rows"> -->
      <!-- <div class="flex md6 xs12">
        <vuestic-widget
          class="chart-widget"
          :headerText="$t('charts.pieChart')"
        >
          <vuestic-chart :data="pieChartData" type="pie"/>
        </vuestic-widget>
      </div>
      <div class="flex md6 xs12">
        <vuestic-widget
          class="chart-widget"
          :headerText="$t('charts.donutChart')"
        >
          <vuestic-chart :data="donutChartData" type="donut"/>
        </vuestic-widget>
      </div> -->
    <!-- </div> -->

    <!-- <div class="va-row">
      <div class="flex md12 xs12">
        <vuestic-widget
          class="chart-widget"
          :headerText="$t('charts.bubbleChart')"
        >
          <vuestic-chart :data="bubbleChartData" type="bubble"/>
        </vuestic-widget>
      </div>
    </div> -->
  <!-- </div> -->
</template>

<script>
// import { getLineChartData } from '../../../data/charts/LineChartData'
// // import BubbleChartData from '../../../data/charts/BubbleChartData'
// import PieChartData from '../../../data/charts/PieChartData'
// import DonutChartData from '../../../data/charts/DonutChartData'
// import VerticalBarChartData from '../../../data/charts/VerticalBarChartData'
// import HorizontalBarChartData from '../../../data/charts/HorizontalBarChartData'
// import SidebarLink from '../../admin/app-sidebar/components/SidebarLink'
import { request } from '@/utils/utils';
export default {
  // name: 'charts',
  // components: {
  //   SidebarLink,
  // },
  // data(){
  //   pieChartData:[{
  //      labels:['Boleto', 'Card', 'Deposit Ecpress'],
  //       datasets:[{
  //       label: 'Population (millions)',
  //       backgroundColor: [primary, warning, danger],
  //       data: [248, 567, 734],
  //     }],
  //   }]
  // },

  // data: () => ({
  //   // bubbleChartData: BubbleChartData,
  //   lineChartData: getLineChartData(),
  //   pieChartData: PieChartData,
  //   donutChartData: DonutChartData,
  //   // verticalBarChartData: VerticalBarChartData,
  //   // horizontalBarChartData: HorizontalBarChartData,
  // }),
  mounted(){
    this.draw();
    this.sdraw();
    // this.chartData();
  },
  methods: {
    draw () {
             // 实例化echarts对象
      let qChart = this.$echarts.init(this.$refs.qChart)
      let token = localStorage.getItem('Authorization')
      let urls = "api/dashboard/report/getReportInfo?start=2019-07-01&end=2019-07-31&access_token="+token+""

            request({
              method: 'post',
              url: urls,
              headers: {'Content-Type': 'application/json'}
            }).then(res=>{
                  this.dashlist=res.data
                  // console.log(this.dashlist)
                  // 绘制条形图
                  qChart.setOption({
                    // color: ['#3398DB'],
                      title : {
                          text: 'Methods Distribution',
                          // subtext: '纯属虚构',
                          left:'top'
                      },
                      tooltip : {
                          trigger: 'item',
                          formatter: "{a} <br/>{b} : {c} ({d}%)"
                      },
                      legend: {
                          orient: 'vertical',
                          bottom: 'left',
                          data: ['CreditCard','Boleto']
                      },
                      series : [
                          {
                              name: '',
                              type: 'pie',
                              radius : '60%',
                              center: ['50%', '50%'],
                              data:[
                                  {value:this.dashlist.method_distribution.CreditCard, name:'CreditCard'},
                                  {value:this.dashlist.method_distribution.Boleto, name:'Boleto'}
                              ],
                              itemStyle: {
                                  emphasis: {
                                      shadowBlur: 10,
                                      shadowOffsetX: 0,
                                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                                  }
                              }
                          }
                      ]
                  })
          // });

      })
    },
    sdraw () {
             // 实例化echarts对象
            let sChart = this.$echarts.init(this.$refs.sChart)
            let token = localStorage.getItem('Authorization')

            let urls = "api/dashboard/report/getReportInfo?start=2019-07-01&end=2019-07-31&access_token="+token+""

            request({
              method: 'post',
              url: urls,
              headers: {'Content-Type': 'application/json'}
            }).then(res=>{
                  this.dashlist=res.data

                  // console.log(this.dashlist)
                 // 绘制条形图
                  sChart.setOption({
                      // color: ['#3398DB'],
                      title : {
                          text: 'Currency',
                          // subtext: '纯属虚构',
                          left:'top'
                      },
                      tooltip: {
                          trigger: 'item',
                          formatter: "{a} <br/>{b}: {c} ({d}%)"
                      },
                      legend: {
                          orient: 'vertical',
                          bottom: 'left',
                          data:['BRL','USD']
                      },
                      series: [
                          {
                              name:'',
                              type:'pie',
                              radius: ['50%', '63%'],
                              avoidLabelOverlap: true,
                              label: {
                                  normal: {
                                      show: false,
                                      position: 'center'
                                  },
                                  emphasis: {
                                      show: true,
                                      textStyle: {
                                          fontSize: '40',
                                          fontWeight: 'bold'
                                      }
                                  }
                              },
                              labelLine: {
                                  normal: {
                                      show: false
                                  }
                              },
                              data:[
                                  {value:this.dashlist.top_countries.BRL, name:'BRL'},
                                  {value:this.dashlist.top_countries.USD, name:'USD'},

                              ]
                          }
                      ]
                  })
                })

         },
  },
    // refreshData () {
    //   this.lineChartData = getLineChartData()
    // },


}
</script>

<style lang="scss">
.charts-page{
  width:100%;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-bottom: 0.3rem;

}
.widget.chart-widget {
  .widget-body {
    height: 550px;

  }
}
.chart_con{
  width: 100%;
  display: flex;
  justify-content: space-around;
}
#qChart {
  width: 48.5%;
  height: 370px;
  margin: 0 20px 30px 0;
  background: #fff;
}
#sChart {
  width: 48.5%;
  height: 370px;
  margin: 0 auto 30px 40px;
  background: #fff;
}
@media screen and (max-width: 750px) {
  #qChart {
    width: 100%;
    margin: 0 auto 20px;
  }
  #sChart {
    width: 100%;
    margin: 0 auto 20px;
  }
}
</style>
